/* Cycle product images every five seconds using the theme's existing gallery controls. */
(() => {
  const initialize = (gallery) => {
    if (gallery.dataset.znAutoplayReady) return;
    const imageSlides = [...gallery.querySelectorAll('.product__media-item[data-media-id]')]
      .filter((slide) => slide.querySelector('.product__modal-opener--image'));
    if (imageSlides.length < 2 || typeof gallery.setActiveMedia !== 'function') return;
    gallery.dataset.znAutoplayReady = 'true';

    let timer;
    let advancing = false;
    let transitionOverlay;
    const clearTransition = () => {
      if (transitionOverlay) transitionOverlay.remove();
      transitionOverlay = null;
    };

    const slideTo = (currentSlide, nextSlide) => {
      const surface = gallery.querySelector('.product__media-list');
      const currentImage = currentSlide && currentSlide.querySelector('img');
      const nextImage = nextSlide.querySelector('img');
      if (!surface || !currentImage || !nextImage ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      clearTransition();
      const overlay = document.createElement('div');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.cssText = 'position:absolute;inset:0;z-index:10;overflow:hidden;pointer-events:none;';

      [currentSlide, nextSlide].forEach((slide) => {
        const original = slide.querySelector('img');
        const imageStyle = window.getComputedStyle(original);
        const pane = document.createElement('div');
        pane.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;overflow:hidden;';
        pane.style.backgroundColor = window.getComputedStyle(slide).backgroundColor;
        const image = original.cloneNode(false);
        image.removeAttribute('id');
        image.removeAttribute('loading');
        image.style.cssText = 'display:block;box-sizing:border-box;width:100%;height:100%;max-width:100%;max-height:100%;object-fit:contain;';
        image.style.objectFit = imageStyle.objectFit;
        image.style.objectPosition = imageStyle.objectPosition;
        image.style.padding = imageStyle.padding;
        image.style.mixBlendMode = imageStyle.mixBlendMode;
        pane.appendChild(image);
        overlay.appendChild(pane);
      });

      surface.style.setProperty('position', 'relative', 'important');
      surface.appendChild(overlay);
      transitionOverlay = overlay;
      const [outgoing, incoming] = overlay.children;
      const animationOptions = { duration: 480, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' };
      outgoing.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }], animationOptions);
      const incomingAnimation = incoming.animate(
        [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }], animationOptions
      );
      incomingAnimation.finished.then(() => {
        if (transitionOverlay === overlay) clearTransition();
      }).catch(() => {});
    };

    const schedule = () => {
      clearTimeout(timer);
      const currentIndex = imageSlides.findIndex((slide) => slide.classList.contains('is-active'));
      const upcomingImage = imageSlides[(currentIndex + 1) % imageSlides.length].querySelector('img');
      if (upcomingImage && upcomingImage.decode) upcomingImage.decode().catch(() => {});
      timer = window.setTimeout(() => {
        if (document.hidden || !gallery.isConnected || document.querySelector('product-modal[open]')) {
          schedule();
          return;
        }
        const current = imageSlides.findIndex((slide) => slide.classList.contains('is-active'));
        const next = imageSlides[(current + 1) % imageSlides.length];
        slideTo(imageSlides[current], next);
        advancing = true;
        gallery.setActiveMedia(next.dataset.mediaId, false);
        advancing = false;
        schedule();
      }, 5000);
    };

    gallery.addEventListener('click', (event) => {
      if (!advancing && event.target.closest('.thumbnail, .slider-button, .zn-gallery-arrow')) {
        clearTransition();
        schedule();
      }
    });
    gallery.addEventListener('touchend', (event) => {
      if (event.target.closest('.product__media-list')) {
        clearTransition();
        schedule();
      }
    }, { passive: true });
    schedule();
  };

  const boot = () => document.querySelectorAll('.template-product media-gallery[id^="MediaGallery-"]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
